const CoreSetting = {
  paysystemTable: {
    id: 'ID',
    name: 'Nombre',
    active: 'Activo',
    paysystems: 'Sistemas de pago',
    showing: 'mostrando',
    noPaysystemsFound: 'No se encontraron sistemas de pago',
  },
  emailTemplatesTable: {
    id: 'ID',
    name: 'Nombre',
    active: 'Activo',
    emailTemplates: 'Notificaciones por correo electrónico',
    showing: 'mostrando',
    noEmailTemplatesFound: 'No se encontraron plantillas de correo electrónico',
  },
  productTable: {
    name: 'Nombre',
    active: 'Activo',
    products: 'Productos',
    showing: 'mostrando',
    noProductsFound: 'No se encontraron productos',
  },
};

export default CoreSetting;
